import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
import $ from 'jquery'; // eslint-disable-line no-restricted-imports

function FieldValidator() {
    this.attributes({
        field: '[data-field-validator]',
        requiredInput: '[data-required-input]',
    });

    this.after('initialize', function() {
        const parentForm = this.$node.closest('form');
        const self = this;
        parentForm.on('submit', e => {
            self.validate(e);
        });
        this.on('keyup', { requiredInput: this.removeValidationErrors });
    });

    this.validate = function(e) {
        const input = this.select('requiredInput');
        if (!this.isValid(input)) {
            this.showValidationErrors();
            e.preventDefault();
        }
    };

    this.isValid = function(input) {
        return input.val().length > 0;
    };

    this.showValidationErrors = function() {
        this.$node.attr('data-field-error', true);
    };

    this.removeValidationErrors = function(e, data) {
        const input = $(data.el);
        if (this.isValid(input)) {
            this.$node.removeAttr('data-field-error');
        }
    };
}

export default defineComponent(FieldValidator);



// WEBPACK FOOTER //
// ./src/js/component_ui/field-validator.js